'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateHighlightUrl, upsertMatchHighlightUrl } from '@nomiss/services';

import { adminBrokenLinksQueryKeys } from './use-admin-broken-links';
import { adminContentHealthQueryKeys } from './use-admin-content-health';

export const adminContentQueryKeys = {
  all: ['admin', 'content'] as const,
};

export function useUpdateHighlightUrl() {
  const queryClient = useQueryClient();
  const updateHighlightUrlMutation = useMutation({
    mutationFn: ({
      id,
      url,
      thumbnailUrl,
    }: {
      id: string;
      url: string;
      thumbnailUrl?: string;
    }) => updateHighlightUrl(id, url, thumbnailUrl),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: adminBrokenLinksQueryKeys.all,
      });
    },
  });

  return { updateHighlightUrlMutation };
}

export function useUpsertMatchHighlightUrl() {
  const queryClient = useQueryClient();
  const upsertMatchHighlightUrlMutation = useMutation({
    mutationFn: ({
      competitionId,
      url,
      thumbnailUrl,
    }: {
      competitionId: string;
      url: string;
      thumbnailUrl?: string;
    }) => upsertMatchHighlightUrl(competitionId, url, thumbnailUrl),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: adminContentHealthQueryKeys.all,
      });
    },
  });

  return { upsertMatchHighlightUrlMutation };
}
